import React from 'react';

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import axios from 'axios';

import { token, host, weekDays, getWeatherIcon, weatherLocations } from '../assets/options';

import RBCarousel from "react-bootstrap-carousel";

class SimpleSlider extends React.Component {
    _isMounted = false;
    constructor(){
        super();

        this.state = {
            data: {}
        }
    }

    componentDidMount () {
        this._isMounted = true;

        axios.post(host + '/api/weather/', {}, {headers: {'authorization': token}})
        .then(res => {
            if (res.status === 200) {
                if(this._isMounted) {
                    this.setState({data: res.data.data});
                }
            } else {
              const error = new Error(res.data.error);
              throw error;
            }
          })
        .catch(err => {
            console.error(err.response?err.response.data.error:err);
        });
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    render () {
        const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
        };

        var today = new Date();

        return (
        <div>
            <Slider {...settings}>

            {weatherLocations.map(loc => {
                const locData = this.state.data[loc.key] || {};
                return (
                    <div key={loc.key}>
                        <div className="ClimateBlocer">
                            <div className="ClimatImage">
                                {locData.state ? <img alt="err" className="ClimatImgMobile" src={getWeatherIcon(locData)}></img> : null}
                            </div>
                            <div className="blck_1">
                                <p>{loc.name}</p>
                                <p>{today.getHours()}:{today.getMinutes()}, {weekDays[today.getDay() - 1]}</p>
                            </div>
                            <div className="blck_2">
                                <p className="sombl">{locData.temperature > 0 ? '+' : ''}{locData.temperature}</p>
                            </div>
                        </div>
                    </div>
                );
            })}

            </Slider>
        </div>
        );
  }
}

class MobileWeather extends React.Component {
    _isMounted = false;

    constructor () {
        super();

        this.state = {
            ad: {},
            slider_time: 0
        }
    }

    async componentDidMount () {
        this._isMounted = true;

        var res = await axios.post(host + '/api/ads/bySize/360x200', {}, {headers: {'authorization': token}})

        this.setState({
            ad: res.data.data,
            slider_time: res.data.time
        })
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    render () {
        return (
            <div className="MobileClimatContainer">

            {this.state.ad.length ? <RBCarousel
                    autoplay={true}
                    pauseOnVisibility={true}
                    slideshowSpeed={this.state.slider_time * 1000}
                    version={4}
                    indicators={false}
                >
                    {this.state.ad.map((item, key) => {
                        return (
                            <a href={item.url} key={key} target="_blank" rel="noopener noreferrer">
                                <div className="climat_Image_Container"
                                style={{backgroundImage: `url(${`${host}/public/uploads/${item.img}`})`}}></div>
                            </a>
                        )
                    })}
                </RBCarousel> : null}

            <div className="mbct">
            <div className="TitleMobile">
                <p>Եղանակ</p>
            </div>
                <SimpleSlider/>
            </div>
        </div>
        );
    }
}

export default MobileWeather;
